var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueYellowRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 97,
    fill: "none",
    viewBox: "0 0 1440 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFE5EC",
    d: "M-.193.097H1439.81L-.193 96.124V.097z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2E2BF",
    d: "M-.193 96.124L1439.81.097v96.027H-.193z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueYellowRectangle);
export default __webpack_public_path__ + "static/media/BlueYellowRectangle.15c0200b9384557f0f78dd2910db87f1.svg";
export { ForwardRef as ReactComponent };